import './ApiCodeToggle.scss';
import { Switch } from 'antd';
import { UpdateQueryParams } from '@hooks';
import React, { useCallback } from 'react';

export type ApiCodeToggleQueryParams = { useInternal?: boolean };

export interface ApiCodeToggleProps {
	checked: boolean;
	onChange: UpdateQueryParams<ApiCodeToggleQueryParams>;
}

export const ApiCodeToggle: React.FC<ApiCodeToggleProps> = ({ checked = false, onChange }) => {
	// Switch onChange passes a second argument that cannot be passed
	// When provided onChange is a setState function.
	const handleOnChange = useCallback((useInternal: boolean) => onChange({ useInternal }), [ onChange ]);

	return (
		<Switch
			checked={ checked }
			checkedChildren='__C'
			className='api-toggle'
			onChange={ handleOnChange }
			unCheckedChildren='__C' />
	);
};
